import root from './internals/root.js';
import { numberIsFinite } from './internals/native.js';

function isFinite(value) {
    return numberIsFinite ? numberIsFinite(value) : typeof value === 'number' && root.isFinite(value);
}

export { isFinite as default };
